import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './SideBarItem.scss';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  clickHandler: PropTypes.func.isRequired,
};

const onKeyDownHandler = () => {};

const SidBarItem = ({
  id, img, label, active, clickHandler,
}) => {
  const itemClassNames = classNames({
    'item-wrapper': true,
    'active-item': active,
  });

  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={onKeyDownHandler}
      onClick={() => { clickHandler(id); }}
      className={itemClassNames}
    >
      <div className="active-item-pointer" />
      <div className="item-img-wrapper">
        <div className="item-img" style={{ backgroundImage: `url(${img})` }} />
      </div>
      <div className="item-label"><span>{label}</span></div>
    </div>
  );
};

SidBarItem.propTypes = propTypes;

export default SidBarItem;



// WEBPACK FOOTER //
// ./src/components/_molecules/SideBar/SideBarItem/SideBarItem.js